import Tooltip from "../Tooltip";
const CandidateTotalScore = ({ resultData }: any) => {
	return (
		<>
			<h2 className="text-xl  text-gray-800 dark:text-white font-subheading">
				Candidate's Overall Result
			</h2>
			<div className="container mx-auto ">
				<div className="flex justify-center overflow-x-auto shadow-xl rounded-md">
					<table className="w-full border-collapse border  text-sm">
						<thead className="font-subheading">
							<tr className="bg-gray-100">
								<th className="p-3 text-left border-r">Normalized Score</th>
								<th className="p-3 text-left">Result</th>
							</tr>
						</thead>
						<tbody className=" font-body">
							<tr>
								<td className="p-3 border-r">Behavioral Score</td>
								<td className="p-3">
									{resultData.score_dashboard?.behavioral_normalized_score || 0}
								</td>
							</tr>
							<tr>
								<td className="p-3 border-r">Technical Score</td>
								<td className="p-3">
									{resultData.score_dashboard?.technical_normalized_score || 0}
								</td>
							</tr>
							<tr>
								<td className="p-3 border-r">Coding Score</td>
								<td className="p-3">
									{resultData.score_dashboard?.coding_normalized_score}
								</td>
							</tr>
							<tr>
								<td className="p-3 font-bold border-r">Total Score</td>
								<td className="p-3 font-bold">
									{resultData.score_dashboard?.total_normalized_score || 0}
								</td>
							</tr>

							<tr className="bg-gray-100">
								<td className="p-3 font-bold flex items-center gap-2 border-r">
									Advance to the Interview Stage
									<div className="mt-2">
										<Tooltip position="top">
											<p className="font-semibold">Recommendation Criteria:</p>
											<ul className="list-disc list-inside">
												<li>
													<b>80+ points:</b> Selected for Interview
												</li>
												<li>
													<b>60-79 points:</b> On Hold
												</li>
												<li>
													<b>Below 60 points:</b> Rejected
												</li>
											</ul>
										</Tooltip>
									</div>
								</td>
								<td className="p-2 font-bold">
									{resultData.score_dashboard?.recommendation === "Rejected"
										? "No"
										: "Yes"}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</>
	);
};

export default CandidateTotalScore;
